import { addDraggableId } from '@/src/tools/helper';
import {
  handleOnClear,
  handleOnGetData,
} from 'src/constrains/ResponsiveLayerEditor/ImagePosterEdit/tool';
import { getSelected } from 'src/constrains/ResponsiveLayerEditor/slice';
import {
  generateCollapseErrorMsgDisplay,
  generateCollapseOpen,
} from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { dispatch, getState as storeState } from 'src/store';
import { ENewTabLayerType } from 'src/types/common/module';

export enum EImageEditCollapse {
  CarouselSetting = 'CarouselSetting',
}

const beforeSubmit = (onContentListResponsiveLayerEditSubmit) => {
  const state = storeState();
  const { type, selected } = getSelected()(state);
  if (type && selected) {
    if (type === ENewTabLayerType.Image || type === ENewTabLayerType.Poster) {
      const newLayerData = handleOnGetData(state); //isSubmitting
      dispatch(
        onContentListResponsiveLayerEditSubmit({
          ...newLayerData,
          //isSubmitting: true,
        }),
      );
      handleOnClear();
    }
  }
  // if (cb) {
  //   setTimeout(cb);
  // }
};

const convertDataFromImage = (data: any) => {
  const {
    layers,
    isNew,
    name,
    image,
    imageLink,
    background,
    autoplayEnabled,
    mute,
    ...rest
  } = data;
  //
  const _layers = addDraggableId(layers || []);
  const dragIds = _layers.map((i) => i.draggableId);
  const fixedIds = [...dragIds, EImageEditCollapse.CarouselSetting];
  const collapseOpen = generateCollapseOpen(fixedIds);
  const collapseErrorMsgDisplay = generateCollapseErrorMsgDisplay(
    fixedIds,
    !isNew,
  );
  //console.log('collapseErrorMsgDisplay', collapseErrorMsgDisplay);
  return {
    ...rest,
    isNew: false,
    name,
    image,
    imageLink,
    background,
    autoplayEnabled,
    mute,
    layers: _layers,
    collapseOpen,
    collapseErrorMsgDisplay,
  };
};
export { convertDataFromImage, beforeSubmit };
